import { Link } from "react-router-dom";
import { NAV, SITE, waLink } from "@/data/site";
import { Wordmark } from "@/components/brand";
import { MessageCircle, Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy-dark text-white">
      <div className="mx-auto max-w-[1400px] px-6 py-16 md:px-12 md:py-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Wordmark dark showTagline={false} />
            <p className="mt-6 max-w-sm font-serif text-2xl italic text-gold">{SITE.tagline}</p>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/70">
              Sankofa Launch Studio — websites, webshops and web apps for Ghanaian schools, hotels and businesses.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-sans text-xs uppercase tracking-[0.2em] text-gold">Explore</h4>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link
                    to={n.to}
                    data-testid={`footer-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-white/75 transition-colors hover:text-gold"
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-sans text-xs uppercase tracking-[0.2em] text-gold">Get in touch</h4>
            <ul className="mt-5 space-y-4 text-sm text-white/80">
              <li>
                <a href={waLink()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-gold" data-testid="footer-whatsapp">
                  <MessageCircle className="h-4 w-4 text-gold" /> WhatsApp {SITE.whatsappDisplay}
                </a>
              </li>
              <li>
                <a href={`tel:${SITE.phoneDisplay.replace(/\s+/g, "")}`} className="flex items-center gap-3 hover:text-gold">
                  <Phone className="h-4 w-4 text-gold" /> Call {SITE.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={`mailto:${SITE.email}`} className="flex items-center gap-3 hover:text-gold">
                  <Mail className="h-4 w-4 text-gold" /> {SITE.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="h-4 w-4 text-gold" /> {SITE.addressLine}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-white/50 md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} Sankofa Launch Studio. All rights reserved.</p>
          <p>Built in Ghana · Mobile-first · WhatsApp &amp; Mobile Money ready</p>
        </div>
      </div>
    </footer>
  );
}
